import * as ACTIONS from "./constants";
import {
  getLocationData,
  getLocationSuggestions,
  getLocationByCoords
} from "../votedata";

export const findLocation = coords => {
  const { key } = getLocationByCoords(coords);

  return {
    type: ACTIONS.FIND_CURRENT_LOCATION,
    payload: {
      location: key,
      details: getLocationData(key)
    },
    meta: {
      analytics: {
        name: "location.geolocationapi",
        section: "intro",
        title: key
      }
    }
  };
};

export const setCurrentLocation = value => ({
  type: ACTIONS.SET_CURRENT_LOCATION,
  payload: {
    location: value,
    details: getLocationData(value)
  },
  meta: {
    analytics: {
      name: "location.autocomplete",
      section: "intro",
      title: value
    }
  }
});

export const setLocationQuery = value => ({
  type: ACTIONS.SET_LOCATION_QUERY,
  payload: {
    value
  }
});

export const getSuggestions = value => ({
  type: ACTIONS.GET_SUGGESTIONS,
  payload: {
    suggestions: getLocationSuggestions(value)
  }
});

export const clearSuggestions = () => ({
  type: ACTIONS.CLEAR_SUGGESTIONS
});



// WEBPACK FOOTER //
// ./src/services/location/actions.js